export class phoneNumberHelper {
    static cleanPhone(phone: string): string {
        const digits = phone.replace(/\D/g, "");

        if ((digits.length === 12 || digits.length === 13) && digits.startsWith("55")) {
            return digits.slice(2);
        }

        return digits;
    }

    static onlyNumbers(value: string): string {
        return value.replace(/\D/g, "");
    }

    static formatPhone(value: string): string {
        const numbers = value.replace(/\D/g, "").slice(0, 11); // Limita a 11 dígitos
        if (numbers.length <= 10) {
            return numbers
                .replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3")
                .trim();
        } else {
            return numbers
                .replace(/^(\d{2})(\d{5})(\d{0,4})$/, "($1) $2-$3")
                .trim();
        }
    }
}
